import { render, staticRenderFns } from "./LinkDetailImage.vue?vue&type=template&id=07aa208d&"
import script from "./LinkDetailImage.vue?vue&type=script&lang=js&"
export * from "./LinkDetailImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports